<script lang="ts">
	import Button from '$lib/components/atoms/button/Button.svelte';
	import * as m from '$paraglide/messages';
	import { createEventDispatcher } from 'svelte';

	export let showRetry = false;
	export let text: string;
	export let errorImage: string;

	const dispatch = createEventDispatcher<{ retry: void; modify: void }>();
</script>

<div class="flex flex-col items-center gap-2 text-sm">
	<span class="text-bold">{text}</span>
	<img src={errorImage} alt="error" />
	<div class="flex gap-4 justify-center">
		{#if showRetry}
			<Button
				variant="outline"
				color="light"
				icon="autorenew"
				text={m.action__retry()}
				class="text-sm"
				onclick={() => dispatch('retry')}
				iconClasses="text-md"
			/>
		{/if}
		<Button
			icon="edit"
			text={m.action__modify()}
			color="light"
			class="text-sm"
			onclick={() => dispatch('modify')}
			iconClasses="text-md"
		/>
	</div>
</div>
